import { Search, TrendingUp } from "lucide-react";
import { useNavigate } from "react-router-dom";

const TRENDING = [
  "aesthetic", "minimal", "fashion", "travel",
  "food", "nature", "photography", "art",
];

const Suggestions = ({ query, users = [], onSelect }) => {
  const navigate = useNavigate();

  return (
    <div className="mt-3 flex flex-col gap-1">

      {/* ✅ Real users — Instagram style */}
      {users.length > 0 && (
        <>
          <p className="text-white/30 text-xs uppercase tracking-wider px-1 mb-1">
            People
          </p>
          {users.slice(0, 5).map((user) => (
            <button
              key={user.id}
              onClick={() => navigate(`/profile/${user.username}`)}
              className="flex items-center gap-3 px-3 py-2.5 rounded-xl
                hover:bg-white/5 transition-colors text-left"
            >
              {/* Avatar */}
              <img
                src={user.profile_icon || user.profile_picture || "/Images/default-avatar.svg"}
                alt={user.username}
                style={{ width: 32, height: 32, borderRadius: "50%", objectFit: "cover", flexShrink: 0, background: "rgba(255,255,255,0.08)" }}
                onError={(e) => { e.target.src = "/Images/default-avatar.svg"; }}
              />
              <div className="flex flex-col">
                <span className="text-white text-sm font-medium">
                  @{user.username}
                </span>
                {user.first_name && (
                  <span className="text-white/30 text-xs">
                    {user.first_name} {user.last_name}
                  </span>
                )}
              </div>
            </button>
          ))}

          <div className="border-t border-white/5 my-2" />
        </>
      )}

      {/* Trending / Text suggestions */}
      <p className="text-white/30 text-xs uppercase tracking-wider px-1 mb-1">
        {query ? "Search for" : "Trending"}
      </p>

      {(query ? [query, ...TRENDING.filter(t =>
        t.toLowerCase().includes(query.toLowerCase())
      )] : TRENDING).slice(0, 6).map((item, i) => (
        <button
          key={i}
          onClick={() => onSelect(item)}
          className="flex items-center gap-3 px-3 py-2.5 rounded-xl
            hover:bg-white/5 transition-colors text-left group"
        >
          {i === 0 && query ? (
            <Search className="w-4 h-4 text-white/30 shrink-0" />
          ) : (
            <TrendingUp className="w-4 h-4 text-white/20 group-hover:text-white/40 shrink-0" />
          )}
          <span className="text-white/70 text-sm group-hover:text-white transition-colors">
            {item}
          </span>
        </button>
      ))}
    </div>
  );
};

export default Suggestions;